<div class="flex flex-col space-y-4">
  <h2>Xero</h2>
  <ng-container [ngSwitch]="status">
    <ng-container *ngSwitchCase="'disconnected'">
      <div class="flex flex-row justify-start items-center space-x-8">
        <p>Status: Disconnected</p>
        <a (click)="getConnectionUrl()"
          ><img src="/assets/xero/connect-blue.svg" alt="Connect Xero"
        /></a>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'unknown'">
      <p>Checking Xero status</p>
    </ng-container>
    <ng-container *ngSwitchCase="'connected'">
      <div class="flex flex-row justify-start items-center space-x-8">
        <p>Status: Connected</p>
        <a (click)="disconnect()"
          ><img src="/assets/xero/disconnect-blue.svg" alt="Disconnect Xero"
        /></a>
        <button mat-stroked-button="primary" (click)="openAccountTaxDialog()">
          Update Account and Tax Configuration
        </button>
        <button
          mat-stroked-button="primary"
          (click)="importContacts()"
          [disabled]="importingContacts"
        >
          Import Contacts
        </button>
        <button mat-stroked-button="primary" (click)="importItems()">
          Import Items as Retail Products
        </button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'connecting'">
      <p>Connecting</p>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
      <p>
        An error occurred checking Xero status or during the connection process.
      </p>
    </ng-container>
  </ng-container>
</div>
